















import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';

import MyList from '@/mixins/list';

import Users from './users.vue';

@Component({
  components: {
    Users,
  },
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;
}
